import React from 'react';

const AlertCustomization = ({ alertSettings, onAlertSettingsChange, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-base-100 rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold">Configuración de Respuesta</h3>
          <button 
            onClick={onClose}
            className="text-base-content hover:text-gray-700"
          >
            ✕
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block mb-2 font-medium">
              Tipo de Respuesta
            </label>
            <select
              value={alertSettings.responseType}
              onChange={(e) => onAlertSettingsChange({
                ...alertSettings,
                responseType: e.target.value
              })}
              className="w-full p-2 border rounded"
            >
              <option value="alert">Mostrar Alerta Personalizada</option>
              <option value="redirect">Redireccionar a URL</option>
            </select>
          </div>

          {alertSettings.responseType === "redirect" ? (
            <div>
              <label className="block mb-2 font-medium">URL de Redirección</label>
              <input
                type="url"
                value={alertSettings.redirectUrl}
                onChange={(e) =>
                  onAlertSettingsChange({
                    ...alertSettings,
                    redirectUrl: e.target.value,
                  })
                }
                placeholder="https://ejemplo.com"
                className="w-full p-2 border rounded"
              />
              <p className="mt-1 text-sm text-gray-500">
                Ingresa la URL completa donde se redireccionará después de enviar el formulario
              </p>
            </div>
          ) : (
            <>
              <div>
                <label className="block mb-2 font-medium">Título de la Alerta</label>
                <input
                  type="text"
                  value={alertSettings.title}
                  onChange={(e) =>
                    onAlertSettingsChange({
                      ...alertSettings,
                      title: e.target.value,
                    })
                  }
                  placeholder="¡Gracias por tu respuesta!"
                  className="w-full p-2 border rounded"
                />
              </div>

              <div>
                <label className="block mb-2 font-medium">Mensaje de la Alerta</label>
                <textarea
                  value={alertSettings.message}
                  onChange={(e) =>
                    onAlertSettingsChange({
                      ...alertSettings,
                      message: e.target.value,
                    })
                  }
                  placeholder="Tus respuestas han sido registradas exitosamente."
                  className="w-full p-2 border rounded h-24"
                />
              </div>

              <div>
                <label className="block mb-2 font-medium">Tipo de Alerta</label>
                <select
                  value={alertSettings.type}
                  onChange={(e) =>
                    onAlertSettingsChange({
                      ...alertSettings,
                      type: e.target.value,
                    })
                  }
                  className="w-full p-2 border rounded"
                >
                  <option value="success">Éxito</option>
                  <option value="info">Información</option>
                  <option value="warning">Advertencia</option>
                </select>
              </div>

              <div>
                <label className="block mb-2 font-medium">Color de Fondo</label>
                <div className="flex items-center space-x-2">
                  <input
                    type="color"
                    value={alertSettings.backgroundColor}
                    onChange={(e) =>
                      onAlertSettingsChange({
                        ...alertSettings,
                        backgroundColor: e.target.value,
                      })
                    }
                    className="h-10 w-20"
                  />
                  <span className="text-sm text-gray-500">
                    Selecciona el color de fondo de la alerta
                  </span>
                </div>
              </div>

              <div>
                <label className="block mb-2 font-medium">Color del Texto</label>
                <div className="flex items-center space-x-2">
                  <input
                    type="color"
                    value={alertSettings.textColor}
                    onChange={(e) =>
                      onAlertSettingsChange({
                        ...alertSettings,
                        textColor: e.target.value,
                      })
                    }
                    className="h-10 w-20"
                  />
                  <span className="text-sm text-gray-500">
                    Selecciona el color del texto de la alerta
                  </span>
                </div>
              </div>
            </>
          )}

          <div className="flex justify-end space-x-2 pt-4 border-t">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 rounded text-base-100 hover:bg-gray-300"
            >
              Cancelar
            </button>
            <button
              onClick={() => {
                // Validación básica
                if (alertSettings.responseType === 'redirect' && !alertSettings.redirectUrl) {
                  alert('Por favor, ingresa una URL válida');
                  return;
                }
                onClose();
              }}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Guardar Cambios
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertCustomization;